<template>
  <div class="error-container">
    <div class="row align-center">
      <div class="columns small-12">
        {{msg}}
      </div>
    </div>
  </div>
</template>

<script>
import { getConfig } from "../utils/index.js";
export default {
  name: "Default",
  data: function(){
    return {
      msg: getConfig('errorMsg')
    }
  }
};
</script>
<style lang="scss">
.error-container{
  
}
</style>
